import request from '@/utils/request'


export function getRule(query) {
    return request({
        url: '/api/activity/spin/rule',
        method: 'get',
        params: query
    })
}


export function getzp(activityId) {
    return request({
        url: '/api/activity/spin/draw?activityId='+activityId,
        method: 'post',
    })
}

export function llRemainCount(query) {
    return request({
        url: '/v1/ll/remain-count',
        method: 'get',
        params: query
    })
}



export function getConfig(query) {
    return request({
        url: '/api/activity/domain/config',
        method: 'get',
        params: query
    })
}


export function getHistory(query) {
    return request({
        url: `/api/dispatch/page`,
        method: 'get',
        params: query
    })
}

export function getRemainCount(query) {
    return request({
        url: '/api/activity/spin/remainCount',
        method: 'get',
        params: query
    })
}

export function getllAward(query) {
    return request({
        url: '/v1/ll/get',
        method: 'get',
        params: query
    })
}


export function authLogin(data) {
    return request({
        url: '/api/auth/login',
        method: 'post',
        data: data
    })
}


export function getLogout(query) {
    return request({
        url: '/api/auth/logout',
        method: 'get',
        params: query
    })
}